// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"139":"category","187":"search","536":"game-records","747":"ranking"}[chunkId] + "." + {"139":"71625804","187":"08d259a7","536":"d49f007d","747":"ead7210f"}[chunkId] + ".js";
};